import React from "react";
import { Container } from "reactstrap";

import {
  carouselItems,
  LitterIntro,
  LitterPage,
  LitterPuppyGrid,
  ParentPedigree,
  VideoSection
} from "components/Litters/LitterComponents.js";
import SEO from "components/SEO/SEO.js";
import DogGallery from "../dogs/DogGallery";

const announcement = require("../../assets/img/dogs/litters/vh2022/announcement.jpg");
const pedigreeImage = require("../../assets/img/dogs/litters/vh2022/pedigree.jpg");
const hopSingProfile = require("../../assets/img/dogs/profile-hop-sing.jpg");
const venusProfile = require("../../assets/img/dogs/profile-venus.jpg");
const agilityIcon = require("../../assets/img/icon-agility.png");
const discIcon = require("../../assets/img/icon-disc.png");
const dockDivingIcon = require("../../assets/img/icon-dockdiving.png");
const flyballIcon = require("../../assets/img/icon-flyball.png");

const puppyImages = {
  pluto: [
    require("../../assets/img/dogs/litters/vh2022/pluto5.jpg"),
    require("../../assets/img/dogs/litters/vh2022/pluto4.jpg"),
    require("../../assets/img/dogs/litters/vh2022/pluto3.jpg"),
    require("../../assets/img/dogs/litters/vh2022/pluto2.jpg"),
    require("../../assets/img/dogs/litters/vh2022/pluto1.jpg")
  ],
  mercury: [
    require("../../assets/img/dogs/litters/vh2022/mercury5.jpg"),
    require("../../assets/img/dogs/litters/vh2022/mercury4.jpg"),
    require("../../assets/img/dogs/litters/vh2022/mercury3.jpg"),
    require("../../assets/img/dogs/litters/vh2022/mercury2.jpg"),
    require("../../assets/img/dogs/litters/vh2022/mercury1.jpg")
  ],
  saturn: [
    require("../../assets/img/dogs/litters/vh2022/saturn5.jpg"),
    require("../../assets/img/dogs/litters/vh2022/saturn4.jpg"),
    require("../../assets/img/dogs/litters/vh2022/saturn3.jpg"),
    require("../../assets/img/dogs/litters/vh2022/saturn2.jpg"),
    require("../../assets/img/dogs/litters/vh2022/saturn1.jpg")
  ],
  jupiter: [
    require("../../assets/img/dogs/litters/vh2022/jupiter5.jpg"),
    require("../../assets/img/dogs/litters/vh2022/jupiter4.jpg"),
    require("../../assets/img/dogs/litters/vh2022/jupiter3.jpg"),
    require("../../assets/img/dogs/litters/vh2022/jupiter2.jpg"),
    require("../../assets/img/dogs/litters/vh2022/jupiter1.jpg")
  ],
  neptune: [
    require("../../assets/img/dogs/litters/vh2022/neptune5.jpg"),
    require("../../assets/img/dogs/litters/vh2022/neptune4.jpg"),
    require("../../assets/img/dogs/litters/vh2022/neptune3.jpg"),
    require("../../assets/img/dogs/litters/vh2022/neptune2.jpg"),
    require("../../assets/img/dogs/litters/vh2022/neptune1.jpg")
  ],
  mars: [
    require("../../assets/img/dogs/litters/vh2022/mars5.jpg"),
    require("../../assets/img/dogs/litters/vh2022/mars4.jpg"),
    require("../../assets/img/dogs/litters/vh2022/mars3.jpg"),
    require("../../assets/img/dogs/litters/vh2022/mars2.jpg"),
    require("../../assets/img/dogs/litters/vh2022/mars1.jpg")
  ],
  moon: [
    require("../../assets/img/dogs/litters/vh2022/moon5.jpg"),
    require("../../assets/img/dogs/litters/vh2022/moon4.jpg"),
    require("../../assets/img/dogs/litters/vh2022/moon3.jpg"),
    require("../../assets/img/dogs/litters/vh2022/moon2.jpg"),
    require("../../assets/img/dogs/litters/vh2022/moon1.jpg")
  ],
  chibiusa: [
    require("../../assets/img/dogs/litters/vh2022/chibiusa5.jpg"),
    require("../../assets/img/dogs/litters/vh2022/chibiusa4.jpg"),
    require("../../assets/img/dogs/litters/vh2022/chibiusa3.jpg"),
    require("../../assets/img/dogs/litters/vh2022/chibiusa2.jpg"),
    require("../../assets/img/dogs/litters/vh2022/chibiusa1.jpg")
  ]
};

const galleryImages = [
  require("../../assets/img/dogs/litters/vh2022/reg1.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg2.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg3.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg4.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg5.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg6.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg7.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg8.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg9.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg10.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg11.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg12.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg13.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg14.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg15.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg16.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg17.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg18.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg19.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg20.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg21.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg22.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg23.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg24.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg25.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg26.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg27.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg28.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg29.jpg"),
  require("../../assets/img/dogs/litters/vh2022/reg30.jpg")
];

const puppies = [
  {
    name: "Cinco",
    registeredName: "Endgame's High Five",
    images: carouselItems(puppyImages.pluto),
    details: [
      { label: "Litter name", value: "Pluto" },
      { label: "Stats", value: "Male, 16\" / 24lbs" },
      { label: "Owner", value: "Donna Jo Staivecki" },
      { label: "Location", value: "PA" },
      { label: "BAER", value: "Normal" }
    ]
  },
  {
    name: "Nimona",
    registeredName: "Endgame's I'm A Shark",
    images: carouselItems(puppyImages.mercury),
    details: [
      { label: "Litter name", value: "Mercury" },
      { label: "Stats", value: "Female, 15.75\" / 20lbs" },
      { label: "Owner", value: "Adriana Nottestad" },
      { label: "Location", value: "NC" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal" },
      { label: "Hips", value: "Pennhip .36/.41, OFA Hips Good" },
      { label: "Other", value: "Shoulders & patellas - OFA normal" }
    ]
  },
  {
    name: "Vox",
    registeredName: "Endgame's Just a Little FOMO",
    images: carouselItems(puppyImages.saturn),
    details: [
      { label: "Litter name", value: "Saturn" },
      { label: "Stats", value: "Male, 15.5\" / 22lbs" },
      { label: "Owner", value: "Alexa Capelletti" },
      { label: "Location", value: "NC" },
      { label: "BAER", value: "Normal" }
    ]
  },
  {
    name: "Moxie",
    registeredName: "Endgame's Hurricane Moxie",
    images: carouselItems(puppyImages.jupiter),
    details: [
      { label: "Litter name", value: "Jupiter" },
      { label: "Stats", value: "Female, 16.25\" / 23lbs" },
      { label: "Owner", value: "Madison Carriere" },
      { label: "Location", value: "WA" },
      { label: "BAER", value: "Normal" }
    ]
  },
  {
    name: "Jyn Erso",
    registeredName: "Endgame's Rebellion Built on Hope",
    images: carouselItems(puppyImages.neptune),
    details: [
      { label: "Litter name", value: "Neptune" },
      { label: "Stats", value: "Female, 14.75\" / 17lbs" },
      { label: "Owner", value: "Alex Nolte" },
      { label: "Location", value: "SC" },
      { label: "BAER", value: "Normal" }
    ]
  },
  {
    name: "Mars",
    registeredName: "Endgame's Out of This World",
    images: carouselItems(puppyImages.mars),
    details: [
      { label: "Litter name", value: "Mars" },
      { label: "Stats", value: "Male, 16\" / 24lbs" },
      { label: "Owner", value: "Jeanette Hutchinson" },
      { label: "Location", value: "MD" },
      { label: "BAER", value: "Normal" }
    ]
  },
  {
    name: "Boone",
    registeredName: "Endgame's Boone",
    images: carouselItems(puppyImages.moon),
    details: [
      { label: "Litter name", value: "Moon" },
      { label: "Stats", value: "Male, 15.75\" / 21lbs" },
      { label: "Owner", value: "Bob & Patte Carbaugh" },
      { label: "Location", value: "TN" },
      { label: "BAER", value: "Normal" }
    ]
  },
  {
    name: "Chibiusa",
    registeredName: "Endgame's Ready for Action",
    images: carouselItems(puppyImages.chibiusa),
    details: [
      { label: "Litter name", value: "Chibiusa" },
      { label: "Stats", value: "Female, 15\" / 19lbs" },
      { label: "Owner", value: "Kama Rueschenberg" },
      { label: "Location", value: "NC" },
      { label: "BAER", value: "Normal" }
    ]
  }
];

const parentHealthSummaries = [
  {
    name: "Venus",
    breed: "Border Collie",
    ofaUrl: "https://ofa.org/advanced-search/?appnum=2263105",
    results: [
      { label: "Hips", value: "OFA Good*, PennHip .32/.35" },
      { label: "Elbows", value: "Normal*" },
      { label: "Shoulders", value: "OFA Normal" },
      { label: "Cardiac", value: "OFA Advanced Cardiac Clear" },
      { label: "Eyes", value: "Clear w/ PSTO (2022, 2025)" },
      { label: "Spine", value: "LTV Free" }
    ]
  },
  {
    name: "Hop Sing",
    breed: "Jack Russell Terrier",
    ofaUrl: "https://ofa.org/advanced-search/?appnum=2588365",
    results: [
      { label: "Patellas", value: "Cleared of luxating patellas" },
      { label: "Eyes", value: "Cleared of eye issues" },
      { label: "Hearing", value: "Normal" },
      { label: "DNA", value: "Clear of breed-relevant testable diseases" }
    ]
  }
];

const sportUpdates = [
  {
    title: "Flyball",
    icon: flyballIcon,
    image: require("../../assets/img/dogs/litters/vh2022/flyball.jpg"),
    imageAlt: "Venus x Hop Sing offspring competing in flyball",
    paragraphs: [
      "Nimona, Vox, Jyn, and Boone are competing in flyball. Nimona, Vox, and Jyn play on That's So Fetch. Boone plays on Big Orange Blast. Boone and his team ran in finals his first Canam/tournament. Nimona and Jyn were on the 2026 Westminster Regular 1 winning team. Vox was on the 2nd place Regular 1 team at Canam in 2025 with his mother Venus."
    ],
    stats: ["Nimona: 3.731", "Vox: 3.720", "Boone: 3.997", "Jyn: 3.798"]
  },
  {
    title: "Agility",
    icon: agilityIcon,
    image: require("../../assets/img/dogs/litters/vh2022/agility.jpg"),
    imageAlt: "Venus x Hop Sing offspring training agility",
    paragraphs: [
      "Chibi, Moxie, and Cinco are currently training competitively in agility. Nimona, Vox, and Jyn will play casually.",
      "Cinco has made multiple national and regional podiums as well as the Senior Open Agility and European open team for the USA in 2026. At SAO, He was 3nd in individiual jumping and 2nd in team agility. He won the eastern regional for the Purina Incredible Dog Challenge in 2026.",
      "Nimona was 1st in the UKI DASH Triathlon in 2026.",
      "Videos of their agility runs can be found on the FB page."
    ]
  },
  {
    title: "Disc",
    icon: discIcon,
    image: require("../../assets/img/dogs/litters/vh2022/disc.jpg"),
    imageAlt: "Venus x Hop Sing offspring playing disc",
    paragraphs: [
      "Nimona, Vox, and Jyn compete in disc.",
      "Nimona is in the expert division in K9 Toss and Fetch with a personal best of 55 (max score). At 10 months, she was ranked #109 out of 3,245 teams in the Spring 2023 season. She was #1 for the summer 2024 90/5 season. Her current UpDog personal bests are 57 in Throw n Go and 175 in Frizgility. She was 2nd in extreme distance at the 2024 Skyhoundz worlds with a 191ft catch and 3rd in microdog sport. At the 2026 Updif nationals, she was 4th overall for 7Up, 2nd for Midi 7UP and Boom, and was in the top 4% of Midi dogs.",
      "Vox plays in UpDog. His personal best in Throw n Go is 55."
    ]
  },
  {
    title: "Dock Diving",
    icon: dockDivingIcon,
    image: require("../../assets/img/dogs/litters/vh2022/dockdiving.jpg"),
    imageAlt: "Venus x Hop Sing offspring dock diving",
    paragraphs: [
      "Nimona and Vox compete in dock diving. Nim's personal best is 26ft 4in, and 17ft in air retrieve. She was ranked the 2023 #1 club lap dog in the USA in Dock Dogs. For the 2024 NADD season, she was #1 lap dog in Air Retrieve and #2 in distance and was 1st place in lap elite hydrodash at the 2024 NADD nationals. For 2025, she was top 10 in all three NADD divisions.",
      "Vox was #1 in the 2026 Body Armour state games Elite division."
    ],
    stats: ["Nimona: 26'4, 17ft AR, 15.202 HD", "Vox: 25'2"]
  }
];

function VH2022Page() {
  return (
    <>
      <SEO
        title="Venus × Hop Sing 2022 | Sport Mix Puppies"
        description="See the Venus x Hop Sing 2022 sport mix puppies from Endgame Sport Dogs near Raleigh NC, including puppy photos, litter updates, health results, and agility, flyball, dock diving, and disc accomplishments."
        path="/litters/venus-hopsing-2022"
      />
      <LitterPage
        headerBg="vh2022"
        pageClassName="litter-detail-page litter-detail-page-modern"
        footerVariant="dark"
      >

        <section className="litter-detail-section litter-overview-section">
          <Container>
            <LitterIntro
              title="Venus × Hop Sing"
              eyebrow="Sport Mix Litter - 2022"
              announcement={announcement}
              announcementAlt="Hop Sing x Venus litter announcement"
              finalCopy={
                <p>
                  For more information about <a className="litter-inline-link" href="/dogs/venus">Venus</a>, view her individual page. For more information on Hop Sing, contact Jeanette Hutchinson or reach out to me if you would like to learn about this cross.
                </p>
              }
              healthParents={parentHealthSummaries}
              overviewCopy={
                <p>Venus and Hop Sing are two dogs with great temperaments. Both dogs are friendly with strangers, get along well in large groups of dogs, and have no environmental sensitivites. Venus had a phenomenal flyball debut posting all sub 4.0 times and getting a personal best of 3.805. She comes from mostly herding lines and has some well known dogs in her pedigree such as Hutchinson's Sweep and Rafter W Flank who had many dock diving accomplishments. Hop Sing has multiple relatives who have made world teams in agility including his littermate Chibi who is on the 2022 European Open team. I expect puppies that can be successful in both novice and experienced homes, and have the physical ability and drive to pursue multiple sports.</p>
              }
              variant="modern"
            />
            <ParentPedigree
              className=""
              parents={[
                { name: "Hop Sing", breed: "Jack Russell Terrier", image: hopSingProfile },
                { name: "Venus", breed: "Border Collie", image: venusProfile, href: "/dogs/venus" }
              ]}
              pedigree={{
                image: pedigreeImage,
                href: "https://dogs.pedigreeonline.com/baybriar-hop-sing-IWoq2g8d/pedigree?hypomating=rafter-w-venus-h6IMYZUB"
              }}
              variant="modern"
            />
          </Container>
        </section>

        <section className="litter-detail-section litter-media-section site-bg-dark-navy">
          <Container>
            <VideoSection
              title="Parent Videos"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.youtube.com/embed/PEZiEg6K7_U", caption: "Venus - Flyball" },
                { src: "https://www.youtube.com/embed/Gub1xyUDvp0", caption: "Venus - Herding" },
                { src: "https://www.youtube.com/embed/D9jV1TERiNU", caption: "Chibi - Agility" },
                { src: "https://www.youtube.com/embed/jreh9nC7dC4", caption: "Chibi - Agility" }
              ]}
            />
          </Container>
        </section>

        <LitterPuppyGrid
          summary="Venus had an easy labor and gave birth to 8 puppies on July 16th, 2022. The litter theme was Sailor Scouts after Venus' namesake character."
          puppies={puppies}
          variant="modern"
        />

        <section className="litter-detail-section litter-updates-section">
          <Container>
            <div className="litter-detail-section-heading">
              <h2>Litter Updates</h2>
              <span className="dog-detail-heading-line" aria-hidden="true"></span>
            </div>
            <div className="litter-update-list">
              {sportUpdates.map(update => (
                <article className="litter-update-item" key={update.title}>
                  <div className="litter-update-icon" aria-hidden="true">
                    <img alt="" src={update.icon} />
                  </div>
                  <div className="litter-update-copy">
                    <h3>{update.title}</h3>
                    {update.paragraphs.map(paragraph => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                    {update.stats && (
                      <div className="litter-update-stats" aria-label={`${update.title} personal bests`}>
                        {update.stats.map(stat => (
                          <span key={stat}>{stat}</span>
                        ))}
                      </div>
                    )}
                  </div>
                  <img className="litter-update-image" alt={update.imageAlt} src={update.image} />
                </article>
              ))}
            </div>
          </Container>
        </section>

        <section className="litter-detail-section litter-media-section litter-group-video-section itter-detail-section litter-gallery-section dog-gallery-section site-bg-dark-navy">
          <Container>
            <VideoSection
              title="Litter Videos"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.youtube.com/embed/videoseries?si=SXIVCLa1opSN5g4z&amp;list=PLWF3G6-urrgg", caption: "2026 Miscellaneous Videos Playlist: Nimona, Cinco, Jyn" },
                { src: "https://www.youtube.com/embed/ucBywyamP3U?si=X5CdoOqXgNIm7Hob", caption: "2 Years - Moxie, Nimona, Boone, Chibiusa, Cinco, Jyn, Vox" },
                { src: "https://www.youtube.com/embed/t-n6fS8_NN8", caption: "12 months - Nimona, Jyn, Vox, Boone, Moxie, Chibi, Cinco" },
                { src: "https://www.youtube.com/embed/IebmrMcSbf0", caption: "6 months - Moxie, Chibiusa, Cinco, Jyn, Vox" }
              ]}
            />
            <div className="padding-header litter-detail-section-heading litter-detail-section-heading-left">
              <h2>Photo album</h2>
              <span className="dog-detail-heading-line" aria-hidden="true"></span>
            </div>
            <DogGallery images={galleryImages} reverseImages />
          </Container>
        </section>
      </LitterPage>
    </>
  );
}

export default VH2022Page;
